import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { config } from '../app.config';
import { map } from 'rxjs/operators';
import get from 'lodash.get';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var SiteSettingsService = /** @class */ (function () {
    function SiteSettingsService(http) {
        this.http = http;
        this.initialPageData = JSON.parse(get(document.getElementById('initialPageData'), 'innerHTML') || null);
    }
    SiteSettingsService.prototype.getSiteSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.cache) return [3 /*break*/, 4];
                        if (!(this.initialPageData && this.initialPageData.siteSettings)) return [3 /*break*/, 1];
                        this.cache = this.mapData(this.initialPageData.siteSettings);
                        return [3 /*break*/, 3];
                    case 1:
                        _a = this;
                        return [4 /*yield*/, this.loadSettings().toPromise()];
                    case 2:
                        _a.cache = _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/, this.cache];
                    case 4: return [2 /*return*/, this.cache];
                }
            });
        });
    };
    SiteSettingsService.prototype.loadSettings = function () {
        var _this = this;
        return this.http.get(config.api + "/siteSettings/get").pipe(map(function (response) { return _this.mapData(response); }));
    };
    SiteSettingsService.prototype.mapData = function (response) {
        return {
            culture: response.culture,
            pageTitleSeparator: response.pageTitleSeparator,
            headerSettings: {
                headerSubLinks: response.headerSubLinks,
                siteTitle: response.siteTitle,
                siteLogo: response.siteLogo
            },
            footerSettings: {
                footerLogo: response.footerLogo,
                footerItems: response.footerItems,
                footerSubscription: response.footerSubscription,
            },
            cookieSettings: {
                cookieTitle: response.cookieTitle,
                cookieDescription: response.cookieDescription
            },
            pageNotFoundPageUrl: response.pageNotFoundPageUrl
        };
    };
    SiteSettingsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SiteSettingsService_Factory() { return new SiteSettingsService(i0.ɵɵinject(i1.HttpClient)); }, token: SiteSettingsService, providedIn: "root" });
    return SiteSettingsService;
}());
export { SiteSettingsService };
